import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";

export default {
  path: "/asset",
  redirect: "/asset",
  name: "Asset",
  component: LAYOUT,
  meta: {
    order: 10,
    title: "素材管理",
  },
  children: [
    {
      path: "",
      name: "AssetPage",
      component: () => import("../../views/asset/AssetPage.vue"),
      meta: {
        title: "素材管理",
        icon: "asset",
        type: 1,
      },
    },
  ],
} as RouteRecordRaw;
